import {
  connectBaseApi,
  createRpcMutation,
  createRpcQuery,
  organizationClient,
  pickupLocationClient,
} from "@racoon/api";

// Pickup location types and customer types: one shape (ConnectProto.OrganizationLabel),
// served per kind. A rename or archive changes what the entity lists show, and the
// type counts come from those lists' facets, so writes refresh them too.
const PICKUP_LOCATION_TYPES = { type: "OrganizationLabel", id: "PICKUP_LOCATION" } as const;
const CUSTOMER_TYPES = { type: "OrganizationLabel", id: "CUSTOMER" } as const;

export const organizationLabelsGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listPickupLocationTypes: createRpcQuery(
      build,
      pickupLocationClient,
      "listPickupLocationTypes",
      {
        providesTags: [PICKUP_LOCATION_TYPES],
      },
    ),
    createPickupLocationType: createRpcMutation(
      build,
      pickupLocationClient,
      "createPickupLocationType",
      { invalidatesTags: [PICKUP_LOCATION_TYPES] },
    ),
    updatePickupLocationType: createRpcMutation(
      build,
      pickupLocationClient,
      "updatePickupLocationType",
      { invalidatesTags: [PICKUP_LOCATION_TYPES, "PickupLocation"] },
    ),
    listCustomerTypes: createRpcQuery(build, organizationClient, "listCustomerTypes", {
      providesTags: [CUSTOMER_TYPES],
    }),
    createCustomerType: createRpcMutation(build, organizationClient, "createCustomerType", {
      invalidatesTags: [CUSTOMER_TYPES],
    }),
    updateCustomerType: createRpcMutation(build, organizationClient, "updateCustomerType", {
      invalidatesTags: [CUSTOMER_TYPES, { type: "Company", id: "LIST" }],
    }),
    setCounterpartyCustomerType: createRpcMutation(
      build,
      organizationClient,
      "setCounterpartyCustomerType",
      { invalidatesTags: [{ type: "Company", id: "LIST" }] },
    ),
  }),
  overrideExisting: false,
});

export const {
  useListPickupLocationTypesQuery,
  useCreatePickupLocationTypeMutation,
  useUpdatePickupLocationTypeMutation,
  useListCustomerTypesQuery,
  useCreateCustomerTypeMutation,
  useUpdateCustomerTypeMutation,
  useSetCounterpartyCustomerTypeMutation,
} = organizationLabelsGrpc;
